/** 后台产品线显示名 / 状态色 / 周期名 / 资源后台链接（相对 adminPath）。 */
export const TYPE_LABEL = {
    cdn: 'CDN', dns: 'DNS', domain: '域名', ssl: 'SSL', yeapmail: '域名邮箱', host_shared: '共享主机', host: '独享容器',
    container: '容器', evm: '云服务器', tm: '邮件推送', disk: '云盘', dedicated: '独立服务器', lightapp: '轻应用', llm: 'AI 接口',
};

export const STATUS_COLOR = {
    active: 'green', pending: 'gold', processing: 'blue', provisioning: 'blue', suspended: 'orange', expired: 'volcano',
    failed: 'red', error: 'red', cancelled: 'default', terminated: 'default',
};

export const STATUS_LABEL = {
    active: '生效中', pending: '待开通', processing: '处理中', provisioning: '开通中', suspended: '已暂停', expired: '已到期',
    failed: '失败', cancelled: '已取消', terminated: '已终止',
};

export const CYCLE_LABEL = {
    monthly: '月付', quarterly: '季付', semi_annually: '半年付', annually: '年付', biennially: '两年', triennially: '三年',
    onetime: '一次性', hourly: '按小时', free: '免费',
};

/** 资源 → 后台详情路由（没有详情页的落到列表页 + 搜索）。 */
export const resourceLink = (type, id, name) => {
    const q = name ? `?search=${encodeURIComponent(name)}` : '';
    switch (type) {
        case 'evm': return `/evm/vms/${id}`;
        case 'cdn': return `/cdn/domains/${id}`;
        case 'dns': return `/dns/records/${id}`;
        case 'domain': return `/domain-registration/detail/${id}`;
        case 'host_shared': return `/host-shared/vhosts/${id}`;
        case 'container': return '/evm/containers/list';
        case 'yeapmail': return `/webmail/domains${q}`;
        case 'ssl': return `/ssl/orders${q}`;
        case 'tm': return `/tm/streams${q}`;
        case 'disk': return '/disk/orgs';
        case 'dedicated': return '/dedicated';
        default: return null;
    }
};

/** 改套餐支持的产品线（与后端 SYNC_UPGRADE + QUEUE_UPGRADE 一致） */
export const PLAN_CHANGE_TYPES = ['cdn', 'dns', 'yeapmail', 'host_shared', 'host', 'tm', 'disk', 'container', 'lightapp'];
